import React from 'react';
import { useFormContext, FieldError } from 'react-hook-form';
import TextInputBase from '../base/TextInputBase.redesign';
import _ from 'lodash';

export interface ITextInputProps {
    label?: string;
    className?: string;
    style?: React.CSSProperties;
    inputType?: 'text' | 'password';
    isRequired?: boolean;
    helperTip?: string;
    name?: string;
    placeholder?: string;
    autoFocus?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    error?: FieldError;
    maxLength?: number;
}

const TextInput: React.FC<ITextInputProps> = (props) => {
    try {
        const { register, errors } = useFormContext();

        const error = _.get(errors, props.name);
        if (error) {
            console.log(error);
        }

        return (
            <TextInputBase
                {...props}
                inputRef={register({ required: props.isRequired ? 'Required Field' : false })}
                error={_.get(errors, props.name)}
                maxLength={props?.maxLength}
            />
        );
    } catch {
        return <div>reactHookForm/TextInput must be inside a react-hook-form FormProvider</div>;
    }
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/controls/forms/reactHookForm/TextInput.tsx